function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _styled from '@emotion/styled/base';
import { ThemeProvider } from '@emotion/react';
import { spinnerThemeNamespace, SpinnerSize, Spinner } from '@tablekit/spinner';
import { ButtonSize } from '../types.js';
import { jsx } from '@emotion/react/jsx-runtime';

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var ButtonLoadingWrapper = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "eiydxsw0"
} : {
  target: "eiydxsw0",
  label: "ButtonLoadingWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "yqtalo",
  styles: "margin-top:2px;position:absolute;left:50%;top:50%;transform:translate(-50%, -50%)"
} : {
  name: "yqtalo",
  styles: "margin-top:2px;position:absolute;left:50%;top:50%;transform:translate(-50%, -50%)",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var spinnerTheme = _defineProperty({}, spinnerThemeNamespace, {
  fillColor: 'currentColor'
});

function composeSpinnerSize(buttonSize) {
  if (buttonSize === ButtonSize.Large) return SpinnerSize.Large;
  return SpinnerSize.Regular;
}

var LoadingSpinner = function LoadingSpinner(_ref) {
  var buttonSize = _ref.size;
  var spinnerSize;

  if (_typeof(buttonSize) === 'object') {
    spinnerSize = Object.keys(buttonSize).reduce(function (result, breakpoint) {
      return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, breakpoint, composeSpinnerSize(buttonSize[breakpoint])));
    }, {});
  } else {
    spinnerSize = composeSpinnerSize(buttonSize);
  }

  return jsx(ThemeProvider, {
    theme: spinnerTheme,
    children: jsx(ButtonLoadingWrapper, {
      children: jsx(Spinner, {
        size: spinnerSize
      })
    })
  });
};

export { LoadingSpinner };
